<template>
  <div>
    <a-form-item :label="$t('cloudenv.text_433')">
      <a-radio-group v-decorator="decorators.cycle_type">
        <a-radio-button v-for="(item, index) in cycleTypeOpts" :key="index" :value="item.k">{{item.v}}</a-radio-button>
      </a-radio-group>
    </a-form-item>
    <a-form-item :label="$t('cloudenv.text_434')" v-if="form.fc.getFieldValue('cycleTimer.cycle_type') === 'week'">
      <a-select v-decorator="decorators.weekDays" mode="multiple">
        <a-select-option v-for="(v, k) in $t('flexGroupSubCycleTypeWeek')" :key="k" :value="parseInt(k)">{{v}}</a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item :label="$t('cloudenv.text_435')" v-if="form.fc.getFieldValue('cycleTimer.cycle_type') === 'month'">
      <a-select v-decorator="decorators.monthDays" mode="multiple">
        <a-select-option v-for="i in 31" :key="i" :value="parseInt(i)">{{$t('cloudenv.text_436', [i])}}</a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item :label="$t('cloudenv.text_435')" v-if="form.fc.getFieldValue('cycleTimer.cycle_type') === 'year'" class="mb-0">
      <div class="d-flex align-items-center">
        <a-form-item class="w-100">
          <a-select v-decorator="decorators.yearMonths" mode="multiple">
            <a-select-option v-for="i in 12" :key="i" :value="parseInt(i)">{{$t('common.date.months', [i])}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item class="w-100 ml-2">
          <a-select v-decorator="decorators.yearDays" mode="multiple">
            <a-select-option v-for="i in 31" :key="i" :value="parseInt(i)">{{$t('cloudenv.text_436', [i])}}</a-select-option>
          </a-select>
        </a-form-item>
      </div>
    </a-form-item>
    <!-- 单次策略 -->
    <template v-if="form.fc.getFieldValue('cycleTimer.cycle_type') === 'one'">
      <a-form-item :label="$t('cloudenv.text_437')">
        <a-date-picker
          :showTime="{
            format: 'HH:mm',
          }"
          :disabledDate="disabledDate"
          :disabledTime="disabledDateTime"
          v-decorator="decorators.execTime"
          format="YYYY-MM-DD HH:mm" />
      </a-form-item>
    </template>
    <!-- 非单次策略 -->
    <template v-if="form.fc.getFieldValue('cycleTimer.cycle_type') !== 'one'">
      <a-form-item :label="$t('cloudenv.text_437')">
        <a-time-picker v-decorator="decorators.hourMinute" format="HH:mm" />
      </a-form-item>
      <!-- <a-form-item :label="$t('cloudenv.text_438')">
        <a-range-picker
          v-decorator="decorators.startEndTime"
          :disabledDate="disabledDate"
          format="YYYY-MM-DD" />
      </a-form-item> -->
    </template>
  </div>
</template>

<script>
export default {
  name: 'CronForm',
  props: {
    form: Object,
  },
  data () {
    return {
      decorators: {
        cycle_type: [
          'cycleTimer.cycle_type',
          {
            initialValue: 'day',
            rules: [
              { required: true, message: this.$t('cloudenv.text_443') },
            ],
          },
        ],
        weekDays: [
          'cycleTimer.week_days',
          {
            initialValue: [1, 2, 3, 4, 5],
            rules: [
              { required: true, message: this.$t('cloudenv.text_444') },
            ],
          },
        ],
        monthDays: [
          'cycleTimer.month_days',
          {
            initialValue: [1],
            rules: [
              { required: true, message: this.$t('cloudenv.text_445') },
            ],
          },
        ],
        yearMonths: [
          'cycleTimer.year_months',
          {
            initialValue: [1],
            rules: [
              {
                required: true,
                validator: (rule, value, callback) => {
                  const values = this.form.fc.getFieldsValue()
                  if (values.cycleTimer.year_months.length > 0 && values.cycleTimer.year_days.length > 0) {
                    callback()
                  }
                  callback(new Error(this.$t('cloudenv.text_445')))
                },
              },
            ],
          },
        ],
        yearDays: [
          'cycleTimer.year_days',
          {
            initialValue: [1],
            rules: [
              {
                required: true,
                validator: (rule, value, callback) => {
                  const values = this.form.fc.getFieldsValue()
                  if (values.cycleTimer.year_months.length > 0 && values.cycleTimer.year_days.length > 0) {
                    callback()
                  }
                  callback(new Error(this.$t('cloudenv.text_445')))
                },
              },
            ],
          },
        ],
        // 小时：分钟
        hourMinute: [
          'hourMinute',
          {
            initialValue: this.$moment().startOf('day').add(2, 'h'),
            rules: [
              { required: true, message: this.$t('cloudenv.text_446') },
            ],
          },
        ],
        // 有效时间
        startEndTime: [
          'startEndTime',
          {
            // initialValue: [1],
            rules: [
              { required: false, message: this.$t('cloudenv.text_447') },
            ],
          },
        ],
        execTime: [
          'timer.execTime',
          {
            initialValue: this.$moment().add(1, 'h'),
            rules: [
              { required: true, message: this.$t('cloudenv.text_437') },
            ],
          },
        ],
      },
    }
  },
  computed: {
    cycleTypeOpts () {
      return ['one', 'day', 'week', 'month', 'year'].map(key => {
        return {
          k: key,
          v: this.$t(`cloudenvScheduledtaskGroupCycleType.${key}`),
        }
      })
    },
  },
  methods: {
    disabledDate (current) {
      return current && current < this.$moment().subtract(1, 'd').endOf('day')
    },
    range (start, end) {
      const result = []
      for (let i = start; i < end; i++) {
        result.push(i)
      }
      return result
    },
    disabledDateTime (_ = this.$moment(), type) {
      let disabledHours = []
      let disabledMinutes = []
      let disabledSeconds = []
      const dayDiff = _.diff(this.$moment(), 'days', true)
      const hourDiff = _.diff(this.$moment(), 'hours', true)
      const minutesDiff = _.diff(this.$moment(), 'minutes', true)
      // 当天
      if (dayDiff > -1 && dayDiff < 0) {
        disabledHours = this.range(0, this.$moment().hour())
        if (hourDiff > -1 && hourDiff < 0) {
          disabledMinutes = this.range(0, this.$moment().minute())
          if (minutesDiff > -1 && minutesDiff < 0) {
            disabledSeconds = this.range(0, this.$moment().second())
          }
        }
      }
      return {
        disabledHours: () => disabledHours,
        disabledMinutes: () => disabledMinutes,
        disabledSeconds: () => disabledSeconds,
      }
    },
  },
}
</script>
